import { render, staticRenderFns } from "./SettlementHistory.vue?vue&type=template&id=684ad0e8&scoped=true&"
import script from "./SettlementHistory.vue?vue&type=script&lang=js&"
export * from "./SettlementHistory.vue?vue&type=script&lang=js&"
import style0 from "./SettlementHistory.vue?vue&type=style&index=0&id=684ad0e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ad0e8",
  null
  
)

export default component.exports